import React from 'react';
import { Grid, Slider, Input, Tooltip } from '@mui/material';

const MIN = 0;
const MAX = 1;
const STEP = 0.01;

interface OverviewSliderProps {
  value: number;
  setValue: (v: number) => void;
  label: string;
  labelTooltip: string;
}

export const OverviewSlider = ({
  value,
  setValue,
  label,
  labelTooltip,
}: OverviewSliderProps) => {
  const [localValue, setLocalValue] = React.useState<number | string>(
    () => value
  );

  React.useEffect(() => {
    // !compare only value not types
    // eslint-disable-next-line eqeqeq
    if (localValue != value) {
      setLocalValue(value);
    }
  }, [value]);

  function onInputBlur() {
    const val = Math.max(MIN, Math.min(MAX, Number(localValue)));
    setLocalValue(val);
    setNewValue(val);
  }

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    setLocalValue(event.target.value);
    setNewValue(event.target.value);
  }

  function setNewValue(v: number | string) {
    const val = Number(v);
    if (val !== value) {
      setValue(val);
    }
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        minWidth: '400px',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Grid item>
        <Tooltip title={labelTooltip} placement="bottom">
          <span
            className="grey-label label-bold"
            style={{ position: 'relative', top: '-3px' }}
          >
            {label}
          </span>
        </Tooltip>
      </Grid>
      <Grid item sx={{ maxWidth: '200px', width: '100%' }}>
        <Slider
          size="small"
          step={STEP}
          min={MIN}
          max={MAX}
          value={sliderValue(localValue)}
          onChange={(e, value) => {
            setLocalValue(value as unknown as number);
            setNewValue(value as unknown as number);
          }}
        />
      </Grid>
      <Grid item>
        <Input
          value={localValue}
          size="small"
          onChange={handleInputChange}
          onBlur={onInputBlur}
          inputProps={{
            step: STEP,
            min: MIN,
            max: MAX,
            type: 'number',
          }}
        />
      </Grid>
    </div>
  );
};

function sliderValue(value: number | string): number {
  return Number(value);
}
